import store from '@/store/store';
import { ITextValue } from '@/types/common';

const getCountries = () => store?.getters?.countries;

export const getCountriesForFilters = (): ITextValue<string>[] => {
  // should be here, as this function called in getDefaultGroupFilterObjectShape where store is init process
  if (!store) {
    return [];
  }

  return getCountries().map((country) => ({
    text: country.name,
    value: country.code,
  })).filter((country) => Boolean(country.value));
};
